import Select, { SingleValue } from 'react-select';
import { useTheme } from 'context/ThemeContext';
import { selectStylesDark, selectStylesLigth } from 'utils/helpers/structs/selectStyles';
import useUserRoles from './struct/userRoles';
import { useState } from 'react';
import type { UserTabProps } from '../../../types';

type RoleOption = { value: string; label: string };

const AccessUserRole = ({ user, dispatchUser }: UserTabProps) => {
    const { darkTheme } = useTheme();
    const [selectTheme] = useState(darkTheme ? selectStylesDark : selectStylesLigth);
    const { userRolesOptions } = useUserRoles();
    const [options] = useState(userRolesOptions);

    return (
        <Select
            options={options}
            styles={{
                ...selectTheme,
                control: (base, state) => ({
                    ...base,
                    ...(selectTheme.control ? selectTheme.control(base, state) : {}),
                }),
            }}
            className="w-100"
            isMulti={false}
            value={options?.find((opt) => opt.value == (user?.access?.role as string))}
            onChange={(aOpt: SingleValue<RoleOption>) => {
                dispatchUser({
                    type: 'SET_ACCESS_FIELD',
                    field: 'role',
                    value: aOpt?.value || '',
                });
            }}
        />
    );
};

export default AccessUserRole;
